import React, { useState } from 'react';
import './CreateCareer.css';
import SummaryApi from '../../../components/common/index'; 

const CreateCareer = () => {
  const initialState = {
    job_title: '',
    job_subtitle: '',
    key_skills: '',
    requirements: '',
    qualification: '',
    number_of_positions: 1,
    is_immediate_join: 0,
    is_closed: 0
  };

  const [formData, setFormData] = useState(initialState);
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    // --- POSITION VALIDATION: PREVENT LESS THAN 1 ---
    if (name === "number_of_positions") {
        if (value !== "" && parseInt(value) < 1) {
            return; // Do not update state if value is less than 1
        }
    }

    const finalValue = type === 'checkbox' ? (checked ? 1 : 0) : value;
    
    setFormData((prev) => ({
      ...prev,
      [name]: finalValue
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(SummaryApi.createCareer.url, {
        method: SummaryApi.createCareer.method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();
      
      if (result.success || response.ok) { 
        alert("Job Post Created Successfully!");
        
        // RESET FORM
        setFormData(initialState);

      } else {
        alert("Error: " + (result.message || "Failed to create job post"));
      }
    } catch (error) {
      console.error("Submission Error:", error);
      alert("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="career-container">
      {/* Career Page Banner */}
      <section className="career-banner">
        <div className="banner-content">
          <h1>Talent Acquisition Portal</h1>
          <p>Draft and visualize your job postings in real-time</p>
        </div>
      </section>

      <div className="main-content-wrapper">
        <div className="split-layout">
          
          {/* LEFT SIDE: THE FORM */}
          <div className="form-column">
            <div className="form-card">
              <h2 className="column-title">Job Details</h2>
              <form onSubmit={handleSubmit} className="career-form">
                <div className="input-group">
                  <label>Job Title</label>
                  <input 
                    type="text" name="job_title" 
                    placeholder="e.g. Senior PHP Developer" 
                    value={formData.job_title} onChange={handleInputChange} required 
                  />
                </div>

                <div className="input-group">
                  <label>Job Subtitle</label>
                  <input 
                    type="text" name="job_subtitle" 
                    placeholder="e.g. Backend Division" 
                    value={formData.job_subtitle} onChange={handleInputChange} 
                  />
                </div>

                <div className="input-row">
                    <div className="input-group">
                    <label>Key Skills</label>
                    <input 
                        type="text" name="key_skills" 
                        placeholder="PHP, MySQL, REST API" 
                        value={formData.key_skills} onChange={handleInputChange} required 
                    />
                    </div>
                    <div className="input-group">
                    <label>Positions</label>
                    <input 
                        type="number" name="number_of_positions" 
                        min="1"
                        value={formData.number_of_positions} onChange={handleInputChange} 
                    />
                    </div>
                </div>

                <div className="input-group">
                  <label>Qualification</label>
                  <input 
                    type="text" name="qualification" 
                    placeholder="e.g. B.Tech / BCA" 
                    value={formData.qualification} onChange={handleInputChange} 
                  />
                </div>

                <div className="input-group">
                  <label>Requirements</label>
                  <textarea 
                    name="requirements" rows="4" 
                    placeholder="Describe the role and expectations..." 
                    value={formData.requirements} onChange={handleInputChange}
                  ></textarea>
                </div>

                <div className="checkbox-row">
                  <label className="custom-checkbox">
                    <input 
                      type="checkbox" name="is_immediate_join" 
                      checked={formData.is_immediate_join === 1} onChange={handleInputChange} 
                    />
                    <span className="checkmark"></span>
                    Immediate Joiner
                  </label>
                </div>

                <button type="submit" disabled={loading} className="submit-btn">
                  {loading ? "Publishing..." : "Publish Job Post"}
                </button>
              </form>
            </div>
          </div>

          {/* RIGHT SIDE: LIVE PREVIEW */}
          <div className="preview-column">
            <div className="sticky-preview">
                <h2 className="column-title">Live Preview</h2>
                <div className={`preview-card ${formData.is_closed === 1 ? 'closed-preview' : ''}`}>
                    <div className="preview-header">
                        <span className="preview-subtitle">{formData.job_subtitle || "Department / Category"}</span>
                        {formData.is_immediate_join === 1 && <span className="urgent-tag">Hiring Now</span>}
                    </div>
                    
                    <h3 className="preview-title">{formData.job_title || "Job Title Preview"}</h3>
                    
                    <div className="preview-section">
                        <label>Required Skills</label>
                        <p>{formData.key_skills || "Waiting for input..."}</p>
                    </div>

                    <div className="preview-grid">
                        <div className="grid-item">
                            <label>Qualification</label>
                            <span>{formData.qualification || "N/A"}</span>
                        </div>
                        <div className="grid-item">
                            <label>Vacancies</label>
                            <span>{formData.number_of_positions} Positions</span>
                        </div>
                    </div>

                    <div className="preview-section">
                        <label>Requirements</label>
                        <div className="preview-desc" >
                            {formData.requirements || "Enter requirements to see them here..."}
                        </div>
                    </div>

                    <button className="preview-apply-btn" disabled>Apply Now</button>
                    {formData.is_closed === 1 && <div className="closed-overlay">This Job is Closed</div>}
                </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default CreateCareer;